import React from 'react';
import { CheckoutShipping } from '../presentation/CheckoutShipping';
import { OrderSummary } from '../presentation/OrderSummary';

export const Shipping = () => {
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 h-full">
      <CheckoutShipping />
      <OrderSummary />
    </div>
  )
}